import React from 'react';
import { NavLink } from 'react-router-dom';
import { createCssClass } from '../helpers/common';

interface StepIndicatorProps {
  steps: {
    name: string;
    path: string;
    svg?: React.ReactNode;
    enabled?: boolean | (() => boolean);
    status?: 'waiting' | 'done' | 'error' | 'current' | 'disabled';
  }[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps }) => {

  const isEnabled = (enabled?: boolean | (() => boolean)): boolean => {
    if (typeof enabled === 'function') return enabled();
    if (typeof enabled === 'boolean') return enabled;
    return true;
  }

  return (
    <nav className='step-indicator' aria-label="step-indicator">
      {steps.map((step, index) => (
        <NavLink
          key={index}
          to={step.path}
          className={createCssClass([() => isEnabled(step.enabled) ? '' : 'disabled', step.status])}
          // className={isEnabled(step.enabled) ? '' : 'disabled'}
          onClick={(e) => {
            if (step.status === 'disabled') e.preventDefault();
          }}
        >
          {step.svg ? step.svg : step.name}
        </NavLink>
      ))}
    </nav>
  );
}

export default StepIndicator